import { FC, ReactNode } from "react"
import clsx from "clsx"

interface SaveButtonProps {
  onClick: () => void | Promise<void>
  loading?: boolean
  disabled?: boolean
  children?: ReactNode
  className?: string
}

export const SaveButton: FC<SaveButtonProps> = ({ onClick, loading = false, disabled = false, children = "Save Changes", className }) => {
  return (
    <button
      className={clsx(
        "btn btn-primary w-1/3 mr-4 self-end bg-transparent text-[rgba(169,78,206,1)] border-[rgba(169,78,206,0.8)] hover:bg-[rgba(169,78,206,0.7)] hover:border-transparent dark:text-white hover:text-white",
        loading && "loading",
        className
      )}
      onClick={onClick}
      disabled={disabled || loading}
    >
      {children}
    </button>
  )
}
